import { prop } from "ramda";
import { createSelector } from "reselect";
import { STATE_IDENTIFIER } from "./constants";

const notifyMgmtSelector = (state: any) => state.consoleAdminNotifyMgmt;

const {
  NOTIFICATIONS,
  NOTIFY_DEL_RESPONSE,
  NOTIFY_ADD_EDT_RESPONSE,
  NOTIFY_REPLAY_RESPONSE,
  LOADER_IDENTIFIER,
  ALL_ROLES,
} = STATE_IDENTIFIER;

export const notifySelector: any = createSelector(
  notifyMgmtSelector,
  prop(NOTIFICATIONS)
);

export const responseDeleteSelector: any = createSelector(
  notifyMgmtSelector,
  prop(NOTIFY_DEL_RESPONSE)
);

export const responseAddEditSelector: any = createSelector(
  notifyMgmtSelector,
  prop(NOTIFY_ADD_EDT_RESPONSE)
);

export const responseReplaySelector: any = createSelector(
  notifyMgmtSelector,
  prop(NOTIFY_REPLAY_RESPONSE)
);

export const notificationLoader: any = createSelector(
  notifyMgmtSelector,
  prop(LOADER_IDENTIFIER)
);

export const allRolesSelector: any = createSelector(
  notifyMgmtSelector,
  prop(ALL_ROLES)
);
